export enum ServerMessagesEnums {
    serverNotAvailable = 'Proxy error: Could not proxy request',
    toastErrorMessageForServerNotAvailable = 'Server trenutno nije dostupan, molimo pokušajte kasnije!',
    deleteErrorMessage404 = 'Došlo je do greške prilikom pokušaja brisanja, pokušajte ponovo!',
  }